// CategoriesSection.jsx
import React from "react";
import { Link } from "react-router-dom";

import { product_categories } from "./index";
import Hero from "./Hero";

const CategoriesSection = ({ isHome }) => {
  const products = [
    {
      id: 1,
      title: "Coir Products",
      description: "Innovative solutions for modern agriculture.",
      label: "Coir Products",
      image: product_categories.category1,
      slug: "cocopit-coir",
    },
    {
      id: 2,
      title: "Organic Fertilizers",
      description: "Nourish your garden with our 100% organic compost.",
      label: "Organic Fertilizers",
      image: product_categories.category2,
      slug: "organic-products",
    },
    {
      id: 3,
      title: "Heena & Fuller's Earth",
      description: "Natural herbal solutions for health and wellness.",
      label: "Herbal & Natural Powder",
      image: product_categories.category3,
      slug: "herbal-products",
    },
      {
      id: 4,
      title: "Bagasse Tableware",
      description: "Eco-friendly tableware made from sugarcane bagasse.",
      label: "Tableware",
      image: product_categories.category4,
      slug: "bagasse-tableware",
    },
  ];

  return (
    <>
      {!isHome && <Hero />}
      <section className="relative w-full bg-[#fff5e1] py-20">
        {/* Background color across the entire section */}
        <div className="absolute inset-0 bg-[#fff5e1]"></div>
        
        {/* Container with padding from both sides */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Title centered with background */}
          <div className="text-center mb-16">
            <h2 className="inline-block text-2xl md:text-2xl font-bold text-white bg-[#8b5e3c] px-8 py-3 shadow-lg">
              Explore Our Product Categories
            </h2>
          </div>

          {/* Product cards grid centered with proper spacing */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {products.map((product) => (
              <Link
                to={`/categories/${product.slug}`}
                key={product.id}
                className="flex justify-center"
              >
                <div className="relative w-full max-w-sm bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                  {/* Category label */}
                  <div className="absolute top-4 left-4 z-10">
                    <span className="bg-[#5b2c23] text-white text-xs font-semibold px-3 py-2 rounded-lg shadow-md">
                      {product.label}
                    </span>
                  </div>

                  {/* Image container */}
                  <div className="w-100 h-60 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Overlay gradient */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>

                  {/* Content */}
                  <div className="bg-gradient-to-br from-[#5b2c23] to-[#7a3f2f] text-white p-6">
                    <h3 className="text-xl font-bold mb-3 group-hover:text-[#f7ebd0] transition-colors duration-300">
                      {product.title}
                    </h3>
                    <p className="text-sm text-gray-200 leading-relaxed">
                      {product.description}
                    </p>
                    
                    {/* Read more arrow */}
                    {/* <div className="mt-4 flex items-center text-[#f7ebd0] text-sm font-medium group-hover:translate-x-2 transition-transform duration-300">
                      Learn more
                      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div> */}
                  </div>

                  {/* Corner decoration */}
                  {/* <div className="absolute top-0 right-0 w-8 h-8 border-t-4 border-r-4 border-[#8b5e3c] rounded-tr-xl"></div> */}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CategoriesSection;

// StaticFeaturesSection.jsx
const StaticFeaturesSection = () => {
  const features = [
    "Rich Flavor",
    "Long Shelf Life",
    "No peeling, chopping, or tears",
    "Healthy & Natural",
  ];

  return (
    <section className="py-12 px-4 md:px-8 bg-amber-50">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-8">
          Pure Onion Goodness - Flavor That Lasts!
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center justify-center space-x-2"
            >
              <div className="w-2 h-2 bg-amber-700 rounded-full"></div>
              <p className="text-lg md:text-xl text-gray-700">{feature}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { CategoriesSection, StaticFeaturesSection };
